import {HFormStructure} from "../../ui/types";

export const modalStructure: HFormStructure = [
  'time', 'driver', 'car'
]
